export default function Features() {
  const features = [
    {
      icon: 'ri-file-shield-2-line',
      title: 'No-Logs Policy',
      description: 'We never track, collect, or share your private data'
    },
    {
      icon: 'ri-shut-down-line',
      title: 'Kill Switch',
      description: 'Automatic protection if your VPN connection drops'
    },
    {
      icon: 'ri-split-cells-horizontal',
      title: 'Split Tunneling',
      description: 'Choose which apps use the VPN connection'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Servers',
      description: 'Connect to servers in multiple countries worldwide'
    },
    {
      icon: 'ri-speed-up-line',
      title: 'High-Speed Connection',
      description: 'Unlimited bandwidth with optimized server performance'
    },
    {
      icon: 'ri-lock-password-line',
      title: 'AES-256 Encryption',
      description: 'Bank-level security protecting all your online activity'
    }
  ];

  return (
    <section id="features" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-16">
          <div className="mb-6 lg:mb-0">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              POWERFUL FEATURES FOR<br />
              <span className="text-orange-500">COMPLETE PRIVACY</span>
            </h2>
            <p className="text-lg text-gray-600">
              Everything you need to stay secure online
            </p>
          </div>
          <div className="inline-flex items-center px-4 py-2 bg-gray-900 text-white text-sm font-semibold rounded-full whitespace-nowrap">
            ENTERPRISE READY
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-3xl p-8 hover:bg-gray-100 transition-all duration-300 hover:shadow-lg group"
            >
              {/* Icon */}
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
